module.exports = __webpack_public_path__ + "static/media/server-network-alt.728c6376.svg";